let routes = [
  {
    path: 'templates',
    name: 'templates',
    component: () => import('./templates.page.vue')
  }
]

export default routes
